<app-table
    [data]="associatedCourses"
    [columns]="associatedCourseColumns"
    [showSearch]="true"
    [searchLabel]="'COMMON.SEARCH' | translate"
    [searchPlacehoder]="'COMMON.SEARCH' | translate"
    [showActionButton]="associatedCourses.length === 0"
    [actionButtonText]="'COMPLIANCE.OVERVIEW.ADD-COMPLIANCE-COURSE' | translate"
    [actionButtonIcon]="'add'"
    (actionFunction)="newComplianceCourseHandler()"
    (onRowClick)="complianceCourseNavigateHandler($event)"
></app-table>
